import type {ReactElement} from 'react';
import {setComponentStyleProperty} from '@FormMakerReact/lib/form-maker-style-library';
import {useComponentStyleProperty} from '@FormMakerReact/lib/form-maker-style-hooks';
import {Text, TextSize} from '@Components/text/text';
import type {FontSizeControlProps, SizeButtonRenderArgs} from './font-size-control.types';
import {FONT_SIZE_PROPERTY} from './font-size-control.types';
import styles from './font-size-control.module.scss';

export function FontSizeControl({component, sizes}: FontSizeControlProps): ReactElement {
  const current = useComponentStyleProperty(component, FONT_SIZE_PROPERTY);
  return (
    <div className={styles.body}>
      <Text val={window.i18next.t('pmwjs_form_maker_control_size_label')} size={TextSize.MD} className={styles.label} />
      <div className={styles.buttons}>
        {sizes.map((size) =>
          renderSizeButton({
            size,
            isActive: current === size.value,
            onSelect: (): void => {
              setComponentStyleProperty(component, FONT_SIZE_PROPERTY, size.value);
            },
          })
        )}
      </div>
    </div>
  );
}

function renderSizeButton({size, isActive, onSelect}: SizeButtonRenderArgs): ReactElement {
  return (
    <button key={size.value} type="button" aria-pressed={isActive} className={`${styles.button} ${isActive ? styles.active : ''}`} onClick={onSelect}>
      <span style={{fontSize: size.value}}>{size.label}</span>
    </button>
  );
}
